import request from '@/utils/request'

let HproductApi = {



    /*获取装修组件的产品列表*/
    listc(data) {
        return request._post('/shop/plus.hproduct.Index/indexc', data);
    },




    /*产品列表*/
    list(data) {
        return request._post('/shop/plus.hproduct.Index/index', data);
    },
    productList(data) {
        return request._post('/shop/plus.hproduct.Index/lista', data);
    },
    listx(data){
        return request._post('/shop/plus.horder.Product/listx',data);
    },
    chooseLists(data) {
        return request._post('/shop/plus.hproduct.Index/listc', data);
    },
    getQuotex(data){
        return request._post('/shop/plus.horder.Product/getQuotex',data);
    },
    createOrder(data){
        return request._post('/shop/plus.horder.Product/createOrder',data);
    },
    updateCustomLabel(data){
        return request._post('/shop/plus.hproduct.Index/updateCustomLabel',data);
    },
    /*添加产品*/
    add(data) {
        return request._post('/shop/plus.hproduct.Index/add', data);
    },
    /*修改产品*/
    edit(data) {
        return request._post('/shop/plus.hproduct.Index/edit', data);
    },
        /*修改产品*/
        editAuth(data) {
            return request._post('/shop/plus.hproduct.Index/editAuth', data);
        },
    editPart(data) {
        return request._post('/shop/plus.hproduct.Index/editPart', data);
    },
    editParts(data) {
        return request._post('/shop/plus.hproduct.Index/editParts', data);
    },
    /*删除产品*/
    del(data) {
        return request._post('/shop/plus.hproduct.Index/del', data);
    },
    /*产品详情*/
    detail(data) {
        return request._post('/shop/plus.hproduct.Index/detail', data);
    },
    saveSetting(data, errorback) {
        return request._post('/shop/plus.hproduct.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.hproduct.Setting/getSetting', data, errorback);
    },
    // 产品上架
    listingProduct(data,errorback) {
        return request._post('/shop/plus.hproduct.Index/shelveProduct', data, errorback);
    },
    // 产品下架
    removeProduct(data,errorback) {
        return request._post('/shop/plus.hproduct.Index/unshelveProduct', data, errorback);
    },
    // 获取变更记录
    getLog(data,errorback) {
        return request._post('/shop/plus.hproduct.Index/getLog', data, errorback);
    },
    // 商品审核
    examine(data,errorback) {
        return request._post('/shop/plus.hproduct.Index/auditProduct', data, errorback);
    },
    /*分类管理*/
    catList(data) {
        return request._post('/shop/plus.hproduct.category/index', data);
    },
    /*分类添加*/
    catAdd(data) {
        return request._post('/shop/plus.hproduct.category/add', data);
    },
    /*分类删除*/
    catDel(data) {
        return request._post('/shop/plus.hproduct.category/delete', data);
    },
    /*分类修改*/
    catEdit(data) {
        return request._post('/shop/plus.hproduct.category/edit', data);
    },
    /*得到分类图片*/
    cateImage(data) {
        return request._post('/shop/plus.hproduct.category/image', data);
    },

    // 获取报价
    calculatePrice(data) {
        return request._post('/shop/plus.hproduct.Index/getQuote', data);
    },

    /*分类管理*/
    attrList(data) {
        return request._post('/shop/plus.hproduct.attr/index', data);
    },
    /*分类添加*/
    attrAdd(data) {
        return request._post('/shop/plus.hproduct.attr/add', data);
    },
    /*分类删除*/
    attrDel(data) {
        return request._post('/shop/plus.hproduct.attr/delete', data);
    },
    /*分类修改*/
    attrEdit(data) {
        return request._post('/shop/plus.hproduct.attr/edit', data);
    },
    /*得到分类图片*/
    attrImage(data) {
        return request._post('/shop/plus.hproduct.attr/image', data);
    },



    /*分类管理*/
    subcategory(data) {
        return request._post('/shop/plus.hproduct_subcategory.Index/index', data);
    },
    /*分类管理*/
    subcategory_add(data) {
        return request._post('/shop/plus.hproduct_subcategory.Index/add', data);
    },
    /*分类管理*/
    subcategory_edit(data) {
        return request._post('/shop/plus.hproduct_subcategory.Index/edit', data);
    },
    /*分类管理*/
    subcategory_detail(data) {
        return request._post('/shop/plus.hproduct_subcategory.Index/detail', data);
    },
    /*分类管理*/
    subcategory_del(data) {
        return request._post('/shop/plus.hproduct_subcategory.Index/del', data);
    },

}
export default HproductApi;


// WEBPACK FOOTER //
// ./src/api/hproduct.js